// main.js
import React from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import cx from "classnames";
import PropTypes from 'prop-types';
import RCore from "RCore";
import UI from 'UI';

class Pitch extends React.Component {

    constructor(props) {
        super(props);
    }

    static contextTypes = {
        screenSizeObserver: PropTypes.object,
        teamLogoSettings: PropTypes.object
    }

    static defaultProps = {
        scaleFactor: 1.0
    }


    componentDidMount() {
      // subscribe to future theme changes
      this.context.screenSizeObserver.subscribe(() => this.forceUpdate())
    }


    renderTeamOnHalfPitch = (lineup, teamSide) => {
        var i = -1;
        var that = this;
        return _.chain(lineup).filter(function (plr) {
            return plr.positionCode > 0;
        }).sortBy(function (plr) {
            return parseInt(plr.positionCode);
        }).groupBy(function (plr) {
            var pos = plr.positionCode + "";
            if (pos.length == 3) return pos[0] + pos[1];
            return pos[0];
        }).map(function (lineup, x, obj) {
            i++;
            var plrsInLine = lineup.length;
            return _.chain(lineup).sortBy(function (plr) {
                return parseInt(plr.positionCode);
            }).map(function (plr, y) {
                return that.renderPlayer(plr.positionCode, plr, teamSide, i, Object.keys(obj).length, y, plrsInLine)
            }).value();
        }).value();
    }
    renderPlayer =  (positionCode, plr, teamSide, x, lines, y, plrsInLine) => {
        //var scaleFactor = (this.state.side == 'home' || this.state.side == 'away') ? 2 : 1;
        var scaleFactor = parseFloat(this.props.scaleFactor);
        var style = {};
        var isHome = teamSide === 'home';

        // let teamId = isHome ? this.props.homeId : this.props.awayId;
        // let shirtUrl = this.getTeamShirtImg(teamId);
        //
        // let linkToPlayer = this.props.linkToPlayer ? this.props.urls.player('soccer', teamId, plr.playerId, plr.name) : null;

        var gap = (plrsInLine == 5) ? 3 * (y % 2 == 0 ? 1 : -1) : 0;
        if (this.isLandscape()) {
            var step = 100 / (plrsInLine);
            style[isHome ? 'left' : 'right'] = scaleFactor * (x / lines * 100  + gap ) + "%";
            style[isHome ? 'bottom' : 'top'] = (y * step + 0.5 * step) + "%";
        } else {
            var step = 100 / (plrsInLine);
            style[isHome ? 'left' : 'right'] = (y * step + 0.5 * step) + "%";
            style[isHome ? 'top' : 'bottom'] = scaleFactor * (x / lines * 100 + gap) + "%";
        }

        var incidents = this.props.event.incidents.filter(inc => inc.participantId === plr.playerId);

        return React.cloneElement(this.props.children, _.extend({
            key: positionCode + "-" + teamSide + "-" + plr.name
        }, {
            incidents: incidents,
            positionCode: positionCode,
            style: style,
            teamId: this.props.event[teamSide + "Id"],
            tournamentId: this.props.event.tournamentTemplateId
        }, plr));
    }
    isLandscape() {
        var media =  this.context.screenSizeObserver;
        return media.isMD() || media.isLG();
    }
    render() {
        let {event, seasonId, showTeamLogos} = this.props;
        let homeLinkParams = {
            teamId: event.homeId,
            teamName: event.homeName,
            seasonId: event.tournamentId,
            tournamentId: event.tournamentTemplateId
        };
        let awayLinkParams = {
            teamId: event.awayId,
            teamName: event.awayName,
            seasonId: event.tournamentId,
            tournamentId: event.tournamentTemplateId
        };
        return (
            <div key="pitch" className={cx("wdp-pitch", {"wdp-pitch__landscape": this.isLandscape(), "wdp-pitch__portrait": !this.isLandscape()})}>
                <div className="wdp-pitch__center-circle wdp-pitch__bars"/>
                <div className="wdp-pitch__half wdp-pitch__half-home">
                    {showTeamLogos ? (
                        <UI.Link action="team" withParams={homeLinkParams}>
                            <UI.TeamLogo className="wdp-pitch__team-logo"  teamId={event.homeId} seasonId={seasonId} />
                        </UI.Link>
                    ) : ""}
                    <span className="wdp-pitch__corner wdp-pitch__bars"/>
                    <span className="wdp-pitch__corner bl wdp-pitch__bars"/>
                    <div className="wdp-pitch__post wdp-pitch__bars"/>
                    <div className="wdp-pitch__straffen wdp-pitch__bars"/>
                    <div className="wdp-pitch__post-circle wdp-pitch__bars">
                        <svg width="80" height="30">
                            <path d="M0,-2 a50,50 0 0,0 80,0" />
                        </svg>
                    </div>

                    {this.renderTeamOnHalfPitch(this.props.home, 'home')}
                </div>
                <div className="wdp-pitch__half wdp-pitch__half-away" >
                    {showTeamLogos ? (
                        <UI.Link action="team" withParams={awayLinkParams}>
                            <UI.TeamLogo className="wdp-pitch__team-logo"  teamId={event.awayId} seasonId={seasonId} />
                        </UI.Link>
                    ) : ""}
                    <span className="wdp-pitch__corner tr wdp-pitch__bars"/>
                    <span className="wdp-pitch__corner br wdp-pitch__bars"/>
                    <div className="wdp-pitch__post wdp-pitch__bars"/>
                    <div className="wdp-pitch__straffen wdp-pitch__bars"/>
                    <div className="wdp-pitch__post-circle wdp-pitch__post-circle_away wdp-pitch__bars">
                        <svg width="80" height="30">
                            <path d="M0,-2 a50,50 0 0,0 80,0" />
                        </svg>
                    </div>
                    {this.renderTeamOnHalfPitch(this.props.away, 'away')}
                </div>
            </div>
        )
    }
}


class Player extends React.Component {

    constructor(props) {
        super(props);
    }
    static contextTypes = {
        plrLogoSettings: PropTypes.object
    }
    render() {
        let {number, teamId, name, playerId, style, showPlayerImages, seasonId, showJerseys, tournamentId} = this.props;
        var linkParams = {
            playerId: playerId,
            teamId: teamId,
            playerName: name,
            tournamentId: tournamentId,
            seasonId: seasonId
        };
        let showPlrLogo = (this.context.plrLogoSettings && this.context.plrLogoSettings.display != 'none')
        return (
            <div style={style} className="wdp-pitch__player">
                <UI.Link action="player" withParams={linkParams}>
                    {showPlrLogo  && <UI.PlayerLogo className="wdp-pitch__player__image" teamId={teamId} playerId={playerId} seasonId={seasonId} />}
                    {!showPlrLogo && <div className="wdp-pitch__player__number">{number}</div>}
                    <div className="wdp-pitch__player__name">{RCore.playerShortName(name)}</div>
                </UI.Link>
            </div>
        )
    }
}

Pitch.Player = Player;
export default Pitch;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/Pitch.js
 **/